/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleAddUpdateResponseDto } from '../models/Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleAddUpdateResponseDto';
import type { Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleImportTemplateParseDto } from '../models/Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleImportTemplateParseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PerformanceRuleLegacyService {

    /**
     * @param isImport
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleAddUpdateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPerformanceRuleLegacyUpdatePerformanceRule(
        isImport?: boolean,
        requestBody?: Array<Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleImportTemplateParseDto>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleAddUpdateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/performance-rule-legacy/update-performance-rule',
            query: {
                'isImport': isImport,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
